module.exports = __webpack_public_path__ + "static/img/blockNum.3551a5a3.png";